import { IsNotEmpty, IsNumber } from 'class-validator';

/**
 * Shared DTO for customerId in request bodies
 * Includes transformation to ensure string values are converted to numbers
 */
export class CustomerIdDto {
  @IsNumber()
  @IsNotEmpty()
  customerId!: number;
}
